<script>
import Layout from "../../../router/layouts/print";
import appConfig from "@/app.config";
// import { saleService } from "../../../services/saleservice/sale.service";


/* eslint-disable no-console */
export default {
  page: {
    title: "Invoice Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      title: "Payment Detail",
      items: [
        {
          text: "Schedule",
          href: "/",
        },
        {
          text: "Detail",
          active: true,
        },
      ],
      saledetail: null,
      saleschedule: null,
      registerDates: [],
      loan: null,
      loanDuration: 0,
      
    };
  },
  mounted() {
    this.saledetail = this.saleDetail;
    this.registerDates = this.saleDetail ? this.saleDetail.register_date.split('-') : [];
    this.saleschedule = this.saleSchedule;
    this.loan = this.loans;
    this.loanDuration = this.duration;
  },

  watch: {

    saleDetail: {
      immediate: true, 
      handler (val) {
        this.saledetail = val;
        this.registerDates = val ? val.register_date.split('-') : [];
      }
    },
    saleSchedule: {
      immediate: true, 
      handler (val) {
        this.saleschedule = val;
      }
    },
    loans: {
      immediate: true, 
      handler (val) {
        this.loan = val;
      }
    },
    duration: {
      immediate: true, 
      handler (val) {
        this.loanDuration = val;
      }
    }
  },

  methods: {
    
    formatCurrency(value, sign = '$') {

      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;

    },

    isAsciiOnly(str) {
        for (var i = 0; i < str.length; i++)
            if (str.charCodeAt(i) <= 127)
                return true;
        return false;
    },
    
    getDay(date) {
      const weekday = ["អាទិត្យ", "ច័ន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍"];
      let d = new Date(date);
      
      return weekday[d.getDay()];
      // console.log(date);
      // return '';
    }
  },


  props: {
    saleDetail: null,
    saleSchedule: null,
    loans: null,
    duration: {
      type: Number,
      default: 0
    }
  }
};

</script>

<template>
  <Layout>
    
        <center>
          <div class="col dblack box-a4-long">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="14%"><p>&nbsp;</p></td>
                <td width="86%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khm h6">លំនៅឋាន អេចស៊ី ឯ.ក</p>
                  <p class="enb h6">LOMNOV THAN HC CO., LTD</p>
                  <p class="en h7">Address: #742 st.:1952, Bayap Village, Sangkat Phnom Penh Thmei, Khan SenSok, Phnom Penh</p>
                  <p class="en h7">Tell: 078 554 077 | 015 554 077 Email: account@h-residence.net</p>
                </td>
              </tr>
              <tr><td colspan="2"><div class="hr-2"></div></td></tr>
            </table>
            <br/>
            <table width="100%" class="content-general"><tr><td class="center">
              <p class="h5 khm">កាលវិភាគបង់ប្រាក់</p>
              <p class="h5 enb">PAYMENT SCHEDULE</p>
              <p class="">
                <img src="@/assets/images/bellow01.png" style="width: 130px;"/>
              </p>
            </td></tr></table>
            <br>

            <table class="content-general h8 detail-table left" width="100%">
              
              <tr>
                <td style="width:3.5cm"><p class="en">Unit Code</p></td>
                <td style="width:2.8cm"><p class="en"><b>: {{saledetail && saledetail.property_code}} Floor: {{saledetail && (saledetail.property_floor + '').padStart(2, '0')}}</b></p></td>
                <td style="width:3cm"><p class="en">Project</p></td>
                <td style="width:4cm"><p class="en"><b>: {{saledetail && saledetail.project_name_en}}</b></p></td>
                <td style="width:3cm"><p class="en">Seller</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.seller_name_en}}</b></p></td>
              </tr>
              <tr>
                <td><p class="en">Unit Price</p></td>
                <td><p class="en"><b>: {{saledetail && formatCurrency(saledetail.amount, '')}} USD</b></p></td>
                <td><p class="en">Type of Agreement</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.contract_type_en}}</b></p></td>
                <td><p class="en">Loan Code</p></td>
                <td><p class="en"><b>: {{loan ? saledetail && saledetail.loan_code : ''}}</b></p></td>
              </tr>
              <tr>
                <td><p class="en">Discount</p></td>
                <td><p class="en"><b>: {{saledetail && formatCurrency(saledetail.discount, '')}} USD</b></p></td>
                <td><p class="en">Customer Code</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.customer_code}}</b></p></td>
                <td><p class="en">Loan Date</p></td>
                <td><p class="en"><b>: {{loan && loan.pay_date_show}}</b></p></td>
              </tr>
              <tr>
                <td><p class="en">Sale Price</p></td>
                <td><p class="en"><b>: {{saledetail && formatCurrency(saledetail.sale_price, '')}} USD</b></p></td>
                <td><p class="en">Customer Name</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.customer_name_en}}</b></p></td>
                <td><p class="en">Loan Amount</p></td>
                <td><p class="en"><b>: {{loan && formatCurrency(loan.principal_pay + loan.balance)}} USD</b></p></td>
              </tr>
              <tr>
                <td><p class="en">Down Payment</p></td>
                <td><p class="en"><b>: {{saledetail && formatCurrency(saledetail.deposit, '')}} USD</b></p></td>
                <td><p class="en">Relationship Name</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.partner_name}}</b></p></td>
                <td><p class="en">Interest Rate</p></td>
                <td><p class="en"><b>: {{loan ? '1%' : '0%'}}/Month</b></p></td>
              </tr>
              <tr>
                <td><p class="en">Principal Paid Total</p></td>
                <td><p class="en"><b>: {{saledetail && formatCurrency(saledetail.principle_pay, '')}} USD</b></p></td>
                <td><p class="en">Customer Phone</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.customer_phone}}</b></p></td>
                <td><p class="en">Loan Period</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.loanDuration}} ខែ</b></p></td>
              </tr>
              <tr>
                <td><p class="en">Remaining Principal</p></td>
                <td><p class="en"><b>: {{saledetail && formatCurrency(saledetail.principle_pending)}} USD</b></p></td>
                <td><p class="en">Indentity Card No.</p></td>
                <td><p class="en"><b>: {{saledetail && saledetail.id_no}}</b></p></td>
                <td><p class="en">Monthly Payment</p></td>
                <td><p class="en"><b>: {{loan && formatCurrency(loan.integer_pay, '')}} USD</b></p></td>
              </tr>
            </table>
            <div style="height: 5px;"></div>
            <table style="width:100%">
              <tr><td colspan="2"><div class="hr-2"></div></td></tr>
            </table>
            <div style="height: 5px;"></div>
            <table class="content-general h8 schedule-table" width="100%">
              <thead>
                <tr>
                  <td><p class="enb">No</p></td>
                  <td colspan="2"><p class="enb">PAYMENT DATE</p></td>
                  <td><p class="enb">PAYMENT</p></td>
                  <td><p class="enb">PRINCIPAL</p></td>
                  <td><p class="enb">INTEREST</p></td>
                  <td><p class="enb">ENDING BALANCE</p></td>
                  <td><p class="enb">PAID DATE</p></td>
                  <td><p class="enb">REMARKE</p></td>
                </tr>
              </thead>
              <tbody>
                <tr style="height: " v-for="(list, index) in saleschedule" :key="list.id">
                  <td><p class="en">{{index+1}}</p></td>
                  <td><p class="en">{{`${list.pay_date_show}`}}</p></td>
                  <td><p class="en" style="font-size: 7pt;">{{list.day_show}}</p></td>
                  <td><p class="en" style="text-align: right; padding-right: 10px">{{formatCurrency(list.integer_pay)}}</p></td>
                  <td><p class="en" style="text-align: right; padding-right: 10px">{{formatCurrency(list.principal_pay)}}</p></td>
                  <td><p class="en" style="text-align: right; padding-right: 10px">{{formatCurrency(list.interest)}}</p></td>
                  <td><p class="en" style="text-align: right; padding-right: 10px">{{formatCurrency(list.balance)}}</p></td>
                  <td><p class="en" style="text-align: center;" v-for="date_list in list.pay_list" :key="date_list.id">{{date_list.pay_date}}</p></td>
                  <td v-if="list.schedule_status_id == 3" style="text-align:center; font-size: 17pt; line-height: 40%; color: #656569;"><span>&#x2611;</span></td>
                  <td v-else style="text-align:center; font-size: 25pt; line-height: 40%; color: #656569;"><span>&squ;</span></td>
                </tr>
                <tr>
                  <td colspan="3"><p class="enb" style="font-size: 11pt;">Total</p></td>
                  <td><p class="enb" style="font-size: 11pt; text-align: right; padding-right: 10px">{{formatCurrency(saleschedule.reduce((sum, item) => sum + item.integer_pay, 0))}}</p></td>
                  <td><p class="enb" style="font-size: 11pt; text-align: right; padding-right: 10px">{{formatCurrency(saleschedule.reduce((sum, item) => sum + item.principal_pay, 0))}}</p></td>
                  <td><p class="enb" style="font-size: 11pt; text-align: right; padding-right: 10px">{{formatCurrency(saleschedule.reduce((sum, item) => sum + item.interest, 0))}}</p></td>
                  <td colspan="3"><p class="en"></p></td>
                  
                </tr>
              </tbody>
            </table>
            <br>
            <table width="100%" class="center">
              <tr><td colspan="3" class="right"><p class="en">Date {{registerDates[2]}}-{{registerDates[1]}}-{{registerDates[0]}} </p></td></tr>
              <tr>
                <td><p class="enb">Thumbprint of Party “B”</p></td>
                <td><p class="enb">Thumbprint of Party “B” Partner</p></td>
                <td><p class="enb">Thumbprint of Party “A”</p></td>
              </tr>
              <tr>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p style="text-align: center" class="khm">{{saledetail && saledetail.customer_name_en}}</p>
                </td>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p style="text-align: center" class="khm">{{saledetail && saledetail.partner_name_en}}</p>
                </td>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p class="khm">LIM TRY</p>
                </td>
              </tr>
            </table>
          </div>
        </center>
  </Layout>
</template>